import { createWidget } from '@typeform/embed';
import '../../../node_modules/@typeform/embed/build/css/widget.css';

export default class ContactTypeForm {
    constructor(element) {
        this.passedElement = element;
        this.searchQuery = "";
        this.init();
    }

    init = () => {
        if (!this.initialised) {
            this.initialised = true;
            this.getElements();
            this.addEventListeners();
        }
    }

    getElements = () => {
        this.formID = this.passedElement.getAttribute('data-form-id');
        this.mobileInline = this.passedElement.getAttribute('data-mobile-inline');
        createWidget(this.formID, { 
            container: this.passedElement,
            hideHeaders: true,
            hideFooter: true,
            autoResize: true,
            inlineOnMobile: true,
            opacity: 0,
            inlineOnMobile: this.mobileInline == 'true',
        })

    }

    addEventListeners = () => {
      //Add all event listeners bellow
    }

}